module.exports = __webpack_public_path__ + "static/media/email07ad82f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/email.svg
// module id = 1476
// module chunks = 0